/*
 * By Evie — collection grid: on hover, the second photo slowly crossfades in
 * (Apple-style). The theme's instant hover swap is switched off in theme settings
 * (show_second_image_on_hover: false). Mouse only; touch is untouched.
 */
(() => {
  const GRID_GALLERY = 'main .product-grid .card-gallery';

  const overlayFor = (gallery) => {
    let overlay = gallery.querySelector(':scope > .bv-hover-image');
    if (overlay) return overlay;

    const second = gallery.querySelectorAll('slideshow-slide img')[1];
    if (!second) return null;

    overlay = document.createElement('img');
    overlay.className = 'bv-hover-image';
    overlay.alt = '';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.decoding = 'async';
    if (second.srcset) overlay.srcset = second.srcset;
    overlay.sizes = second.sizes || '100vw';
    overlay.src = second.currentSrc || second.src;
    gallery.appendChild(overlay);
    return overlay;
  };

  const init = () => {
    document.querySelectorAll(GRID_GALLERY).forEach((gallery) => {
      if (gallery.dataset.bvCrossfade) return;
      gallery.dataset.bvCrossfade = 'true';

      // Prepare the second photo ahead of time so the fade never flashes
      setTimeout(() => overlayFor(gallery), 600);

      gallery.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        overlayFor(gallery)?.classList.add('is-visible');
      });

      gallery.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        overlayFor(gallery)?.classList.remove('is-visible');
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
